import PicklistMetadata from "../PicklistMetadata";

// How a credential set authenticates. Note this is the METHOD only: whether the secret is stored
// here or referenced in a vault is a separate switch, exactly as it is in Ataccama.
class ConnectionCredentialAuthenticationTypePicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "ConnectionCredentialAuthenticationType";
        this.bounded = true;
        this.enterpriseComponent = "PickList Generic";
        this.longList = false;
        this.noDelete = true;
        this.noUpdate = true;
        this.noInsert = true;
        this.noMerge = true;
        this.searchSpecification = null;
        this.sortSpecification = null;
        this.static = true;
        this.typeField = "Type";
        this.typeValue = "Connection Credential Authentication";
        this.typeValue2 = null;
        this.visibilityType = null;
    }
}

export default ConnectionCredentialAuthenticationTypePicklistMetadata;
